import React, { Component } from 'react';
import Typography from 'material-ui/Typography';
import ReactTable from 'react-table';
import 'react-table/react-table.css';
import QueryService from './QueryService';
import { FormGroup, FormControlLabel } from 'material-ui/Form';
import Switch from 'material-ui/Switch';

class UsersPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            users: [],
            error: false,
        };
    }

    componentDidMount() {
        QueryService.get('/users')
            .then(json => {
                this.setState({users: json.data});
            })
            .catch(err => {
                console.log('cannot fetch users, could be redirection error due to not being logged in', err);
                this.setState({error: true});
            });
    }

    updateUser(props, attributeName, attributeValue) {
        const users = [...this.state.users];
        users[props.index].attributes[attributeName] = !attributeValue;
        QueryService.put('/users/' + users[props.index].id, {[attributeName]: !attributeValue})
            .then(resp => {
                this.setState({users: users});
            })
            .catch(err => {
                console.log('Cannot update user', err);
                this.setState({error: true});
            });
    }

    renderToggleableAttribute(props, attributeName, trueLabel, falseLabel) {
        var attributeValue = this.state.users[props.index].attributes[attributeName];
        if (attributeValue === null) { // Somehow null values cause the controlled vs uncontrolled warning message
            attributeValue = false;
        }
        const label = attributeValue ? trueLabel : falseLabel;
        return (
            <FormGroup row>
              <FormControlLabel
                control={
                        <Switch
                              checked={attributeValue}
                              color="primary"
                              onChange={() => {
                                  this.updateUser(props, attributeName, attributeValue);
                              }}
                              />
                        }
                        label={label}
                        />
            </FormGroup>
        );
    }

    renderReadOnlyAttribute(props, attributeName, trueLabel, falseLabel) {
        var attributeValue = this.state.users[props.index].attributes[attributeName];
        if (attributeValue === null) { // Somehow null values cause the controlled vs uncontrolled warning message
            attributeValue = false;
        }
        const label = attributeValue ? trueLabel : falseLabel;
        return (
            <Typography>{label}</Typography>
        );

    }

    render() {
        const {users, error} = this.state;
        if (! error) {
            const columns = [
                {
                    Header: 'Name',
                    accessor: 'attributes.name',
                    Cell: props => <Typography>{props.value}</Typography>
                },
                {
                    Header: 'Email',
                    accessor: 'attributes.email',
                    Cell: props => <Typography>{props.value}</Typography>
                },
                {
                    Header: 'User disabled',
                    accessor: 'attributes.disabled',
                    Cell: props => this.renderToggleableAttribute(props, 'disabled', 'Disabled', 'Active')
                },
                {
                    Header: 'opted out from Emails',
                    accessor: 'attributes.email_optout',
                    Cell: props => this.renderToggleableAttribute(props, 'email_optout', 'opted out from emails', 'accepts emails')
                },
                {
                    Header: 'Accepted TOS',
                    accessor: 'attributes.tos',
                    Cell: props => this.renderReadOnlyAttribute(props, 'tos', 'agree to TOS', 'has not agreed to TOS')
                },
                {
                    Header: 'Email address bouncing',
                    accessor: 'attributes.failing_email_address',
                    Cell: props => this.renderReadOnlyAttribute(props, 'failing_email_address', 'email address errors', 'no known email issue')
                },
            ];

            return (
                <div>
                  <Typography variant="title">Users</Typography>
                  <ReactTable data={users} columns={columns} className='-striped' defaultPageSize={50} />
                </div>
            );
        } else {
            return <div>Error!</div>;
        }
    }
}

export default UsersPage;



// WEBPACK FOOTER //
// ./src/Users.js